import { Box, Button, IconButton, InputAdornment, Skeleton, TextField } from "@mui/material";
import { ChevronLeft, ChevronRight, Plus, Search, Trash } from "lucide-react";
import { memo } from "react";

import { useNursingFunctionsContext, NursingFunctionsProvider } from "./NursingFunctionsProvider";
import AssignFunctionModal from "../../widgets/AssignFunctionModal/AssignFunctionModal";
import ConfirmDeleteModal from "../../widgets/ConfirmDeleteModal/ConfirmDeleteModal";
import TableCustom from "./Table/TableCustom";
import { PillList } from "./PillList";
import "./NursingFunctions.scss";

function Header() {
	const { setQuery, canDelete, showDeleteModal, setShowDeleteModal, showModal, setShowModal } =
		useNursingFunctionsContext();

	return (
		<Box className="functions__header">
			<TextField
				className="functions__header__textfield"
				type="text"
				placeholder="Buscar"
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<Search size={15} />
						</InputAdornment>
					),
				}}
				onChange={(event) => setQuery(event.target.value.toLocaleLowerCase())}
			/>
			<Box
				id="onboarding-11"
				display={"flex"}
			>
				<Button
					className="functions__header__trash-button"
					startIcon={<Trash />}
					onClick={() => setShowDeleteModal(true)}
					disabled={!canDelete()}
				>
					Baja
				</Button>
				<Button
					className="functions__header__add-button"
					startIcon={<Plus />}
					onClick={() => setShowModal(true)}
				>
					Asignar función
				</Button>
			</Box>
			<ConfirmDeleteModal
				open={showDeleteModal}
				onClose={() => {
					setShowDeleteModal(false);
				}}
			/>

			<AssignFunctionModal
				open={showModal}
				onClose={() => setShowModal(false)}
			/>
		</Box>
	);
}

function Pills() {
	const { containerRef, canScrollRight, canScrollLeft, handleScroll, areas } =
		useNursingFunctionsContext();

	return (
		areas.length > 0 ? (
		<Box className="functions__options">
			{canScrollLeft && (
				<IconButton
					className="functions__options__arrows functions__options__arrows--left"
					onClick={() => handleScroll("left")}
					disableRipple
				>
					<ChevronLeft />
				</IconButton>
			)}
			<Box
				className="functions__options__content"
				ref={containerRef}
			>
				<PillList />
			</Box>
			{canScrollRight && (
				<IconButton
					className="functions__options__arrows functions__options__arrows--right"
					onClick={() => handleScroll("right")}
					disableRipple
				>
					<ChevronRight />
				</IconButton>
			)}
		</Box>
		)
		: (
			<Box className="skeleton__pills-row">
				{Array.from({ length: 12 }).map(() => (
					<Skeleton
						sx={{ borderRadius: "16px" }}
						variant="rounded"
						width={150}
						height={35}
					/>
				))}
			</Box>
		)
		
	);
}

function NursingFunctions() {
	return (
		<NursingFunctionsProvider>
			<Box className="home__body">
				<Box className="functions">
					<Header />
					<Pills />

					<TableCustom />
				</Box>
			</Box>
		</NursingFunctionsProvider>
	);
}

export default memo(NursingFunctions);
